export default "/images/38ccf231d5559524c2b66b3525257517.avif";